import type { RadioConfig } from '#types/config/components/vf/radio'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      shared: 'mt-0.5 p-0.75 h-4 w-4',
      variant: {
        base: {
          default: 'ring-brand-1',
          selected: 'ring-brand-1 c-brand-1'
        },
        inverse: {
          default: 'ring-brand-2',
          selected: 'ring-brand-2 c-brand-2'
        }
      }
    },
    label: {
      shared: 'body-3',
      variant: {
        base: {
          default: 'c-brand-1'
        },
        inverse: {
          default: 'c-brand-2'
        }
      }
    },
    wrapper: {
      shared: 'gap-x-2 items-start'
    }
  }
} satisfies RecursivePartial<RadioConfig>
